<script setup lang="ts">
  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'primary',
    },
  })
</script>

<!-- eslint-disable vuejs-accessibility/label-has-for -->
<template>
  <div>
    <input
      id="check-box-id"
      type="checkbox"
      :class="[`form-check-input form-check-input--${props.type}`, 'me-2']"
      :checked="props.modelValue"
      @change="$emit('update:modelValue', !props.modelValue)"
    />
    <label class="form-check-label" for="check-box-id">
      {{ props.label }}
    </label>
  </div>
</template>
